import BitcoinShort from "/static/img/home-page/slider/btc-s.svg";
import EthereumShort from "/static/img/home-page/slider/eth-s.svg";
import TokemakShort from "/static/img/home-page/slider/toke-s.svg";
import LinkShort from "/static/img/home-page/slider/link-s.svg";
import EuroShort from "/static/img/home-page/slider/euro-s.svg";
import AvalancheShort from "/static/img/home-page/slider/aave-s.svg";
import BitcoinLong from "/static/img/home-page/slider/btc-l.svg";
import EthereumLong from "/static/img/home-page/slider/eth-l.svg";
import TokemakLong from "/static/img/home-page/slider/toke-l.svg";
import LinkLong from "/static/img/home-page/slider/link-l.svg";
import EuroLong from "/static/img/home-page/slider/euro-l.svg";
import AvalancheLong from "/static/img/home-page/slider/aave-l.svg";

export const shortPosTokens = [
  {
    name: "1S-BTC/USDC",
    image: BitcoinShort,
  },
  {
    name: "3S-BTC/USDC",
    image: BitcoinShort,
  },
  {
    name: "1S-ETH/USDC",
    image: EthereumShort,
  },
  {
    name: "3S-ETH/USDC",
    image: EthereumShort,
  },
  {
    name: "3S-TOKE/USDC",
    image: TokemakShort,
  },
  {
    name: "3S-LINK/USDC",
    image: LinkShort,
  },
  {
    name: "1S-EURO/USDC",
    image: EuroShort,
  },
  {
    name: "3S-EURO/USDC",
    image: EthereumShort,
  },
  {
    name: "3S-AAVE/USDC",
    image: AvalancheShort,
  },
];

export const longPosTokens = [
  {
    name: "1L-BTC/USDC",
    image: BitcoinLong,
  },
  {
    name: "3L-BTC/USDC",
    image: BitcoinLong,
  },
  {
    name: "1L-ETH/USDC",
    image: EthereumLong,
  },
  {
    name: "3L-ETH/USDC",
    image: EthereumLong,
  },
  {
    name: "3L-TOKE/USDC",
    image: TokemakLong,
  },
  {
    name: "3L-LINK/USDC",
    image: LinkLong,
  },
  {
    name: "1L-EURO/USDC",
    image: EuroLong,
  },
  {
    name: "3L-EURO/USDC",
    image: EuroLong,
  },
  {
    name: "3L-AAVE/USDC",
    image: AvalancheLong,
  },
];
